import { push } from "connected-react-router";
import ReactGA from "react-ga4";
import * as api from "api";
import * as utils from "common/utils";
import appActions from "containers/App/_actions";
import { updateBudget } from "containers/Budget/_actions";

export const deleteBlock = (budget, blockId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Block",
            action: "Delete",
        });

        utils.deleteOrphanBlockRef(budget, blockId);
        budget.blocks = budget.blocks.filter((b) => b.id !== blockId);

        dispatch(updateBudget(budget))
            .then((response) => {
                resolve(response);
                return [];
            })
            .catch((error) => {
                reject(error);
                return [];
            });
    });
};

export function completeBlocks(budget, farmId, goToCrops) {
    return (dispatch) => {
        dispatch(updateBudget(budget));
        if (goToCrops) {
            dispatch(push(`/app/farm/${farmId}/analysis/${budget.id}/crops`));
        }
        dispatch({ type: appActions.APP_CLOSE_MODAL });
    };
}

// Get Analysis GeoJson
export const getAnalysisGeoJsonAsync = {
    send: (farmId, analysisId) => (dispatch) => {
        return new Promise((resolve, reject) => {
            ReactGA.event({
                category: "Spatial",
                action: "Get Analysis GeoJSON",
            });
            dispatch(
                api.get({
                    path: `farms/${farmId}/analyses/${analysisId}/geojson`,
                    onSuccess: (response) => {
                        resolve(response);
                        return [];
                    },
                    onFailure: (error) => {
                        error.handled = true;
                        reject("Error loading map data");
                        return [];
                    },
                    cancelActionType: "abort_getAnalysisGeoJsonAsync",
                })
            );
        });
    },
    abort: () => (dispatch) => dispatch({ type: "abort_getAnalysisGeoJsonAsync" }),
};

// Get all Analysis GeoJsons for a farm
export const getFarmAnalysesWithGeoJsonAsync = {
    send: (farmId) => (dispatch) => {
        return new Promise((resolve, reject) => {
            ReactGA.event({
                category: "Spatial",
                action: "Get All Analysis GeoJSONs by Farm",
            });
            dispatch(
                api.get({
                    path: `farms/${farmId}/analyses/geojson`,
                    timeout: 120000,
                    onSuccess: (response) => {
                        resolve(response);
                        return [];
                    },
                    onFailure: (error) => {
                        console.log(error);
                        error.handled = true;
                        reject("Error loading map data");
                        return [];
                    },
                    cancelActionType: "abort_getFarmAnalysesWithGeoJsonAsync",
                })
            );
        });
    },
    abort: () => (dispatch) => dispatch({ type: "abort_getFarmAnalysesWithGeoJsonAsync" }),
};

// Update Analysis GeoJson
export const updateAnalysisGeoJsonAsync = (analysis, features) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Budget",
            action: "Update Budget with GeoJson",
        });

        // Copy geojson features to the budget.
        analysis.features = features
            .filter((feature) => ["Block", "UnassignedLand", "OtherBlock", "Irrigator"].includes(feature.properties.layer))
            .map((feature) => {
                // There are a bunch of feature properties we added for UX purposes
                // that we don't want to store in the db.
                // Only send through the feature properties we won't to store.
                const properties = { ...feature.properties };
                delete properties.visible;
                delete properties.hovered;
                delete properties.selected;
                delete properties.blockAreas;
                delete feature.error;
                delete feature.scrollRef;

                if (properties.layer === "OtherBlock") {
                    properties.layer = "Block";
                }

                const block = (analysis.blocks || []).find((b) => b.id === properties.blockId);
                if (block) {
                    properties.blockName = block.name;
                }

                return { ...feature, properties };
            });

        analysis.isDrawn = analysis.features.length > 0;

        analysis.blocks = analysis.blocks.map((b) => {
            return { ...b, climate: undefined };
        });
        // Go thru normal updateBudgte logic.
        dispatch(updateBudget(analysis))
            .then((response) => {
                resolve(response);
                return [];
            })
            .catch((error) => {
                reject(error);
                return [];
            });
    });
};
